import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { PageContentBox, WizardContentBox } from '../../components/element';
import { PageTitleBox } from '../../components/menu';
import Strings from '../../locales/Strings';
import { Wizard, WizardStepCheckItem, WizardStepDescription } from '../../components/wizard';
import { getWizardTechDocAction, toggleSideMenu } from '../../actions';
import { VideoBox } from '../../components/video';
import { PageNavBar } from '../../components/page';
import { getQueryString, getQueryStringValues, validateSelectors } from '../../utils/withPath';
import { getDownloadInstallationGuideUrl, getPageContentReducerKey } from '../../utils/utils';
import { PRODUCT_ID_CLOUD, PRODUCT_ID_BAAS, STORAGE_PURCHASE_OPT_SUBSCRIBED } from '../../constants';
export default function TechDocWizardPage(props) {
  const history = props.history;
  const location = props.location;

  const dispatch = useDispatch();
  const queryStringValues = getQueryStringValues(props.location);
  const pageOpt = queryStringValues['opt'];
  const storagePurchaseOpt = queryStringValues['storagepurchaseopt'];
  const [arrayModel] = useState(queryStringValues.model);
  const [pageProps] = useState(props.pageProps);
  const [downloadFullDocUrl, setDownloadFullDocUrl] = useState('');
  const [downloadFullDocLabel, setDownloadFullDocLabel] = useState('');
  const pageName = pageProps.pageName;
  const productName = queryStringValues['product'];
  const simplivitymodel = queryStringValues['simplivitymodel'];
  const hpeAlletraDHCImodel = queryStringValues['hpeAlletraDHCImodel'];
  // const { downloadFullDocUrl, downloadFullDocLabel } = getDownloadInstallationGuideUrl({ productName, pageOpt });

  // !arrayModel && history.replace(gettingStartedPath);
  const modelList = useSelector(props => props.techDocReducer['modelList']);
  const reducerKey = getPageContentReducerKey({ pageName, model: arrayModel, pageOpt });
  const stepsContent = useSelector(props => props.techDocReducer[reducerKey]);
  useEffect(() => {
    if (modelList && Object.keys(modelList).length > 0 && validateSelectors({ location, history, modelList })) {
      const modelDocConfig = modelList[arrayModel];
      const productId = pageName === PRODUCT_ID_CLOUD ? PRODUCT_ID_CLOUD : modelDocConfig.productId;
      const downloadDocObj = getDownloadInstallationGuideUrl({
        productName: productId,
        pageOpt,
        simplivitymodel,
        hpeAlletraDHCImodel,
        arrayModel,
      });
      setDownloadFullDocUrl(downloadDocObj.downloadFullDocUrl);
      setDownloadFullDocLabel(downloadDocObj.downloadFullDocLabel);

      // !modelDocConfig && history.replace(gettingStartedPath);
      !stepsContent &&
        getWizardTechDocAction({
          modelDocConfig,
          pageName,
          pageOpt,
          productName,
          model: arrayModel,
          simplivitymodel,
          hpeAlletraDHCImodel,
          dispatch,
        });
    }
  }, [
    modelList,
    arrayModel,
    pageName,
    pageOpt,
    productName,
    history,
    location,
    stepsContent,
    simplivitymodel,
    hpeAlletraDHCImodel,
    dispatch,
  ]);

  const pageCategory = '' || pageProps.category;
  const path = props.location.pathname.replace(/\/\d*$/, '');
  const steps = stepsContent ? stepsContent : [];
  let step = Number(props.match.params.step);
  step = isNaN(step) ? 1 : step;
  let prevStep = !steps || step === 1 ? pageProps.prevPage : `${path}/${step - 1}`;
  let nextStep = !steps || step === steps.length ? pageProps.nextPage : `${path}/${step + 1}`;
  const queryString = getQueryString(props.location);
  let videoUrl = '';
  if (pageProps.steps.length > 0) {
    const videoUrlObj = pageProps.steps && (pageProps.steps[step - 1] || pageProps.steps[0]);
    if (!videoUrlObj) {
      history.replace('/');
      return null;
    }
    if (productName === PRODUCT_ID_BAAS && storagePurchaseOpt === STORAGE_PURCHASE_OPT_SUBSCRIBED) {
      videoUrl = videoUrlObj[`videoUrl_${storagePurchaseOpt}`]
        ? videoUrlObj[`videoUrl_${storagePurchaseOpt}`]
        : videoUrlObj['videoUrl'];
    } else {
      videoUrl = videoUrlObj[`videoUrl_${pageOpt}`] ? videoUrlObj[`videoUrl_${pageOpt}`] : videoUrlObj['videoUrl'];
    }
  }
  return (
    <PageContentBox fill={true}>
      <PageTitleBox
        id="pageTitle1"
        className="noBottomBorder"
        responsive={props.responsive}
        title={Strings[pageName]}
        category={Strings[pageCategory]}
        onResponsiveMenuIconClick={() => toggleSideMenu(true, dispatch)}
        downloadUrl={downloadFullDocUrl}
        downloadTitle={downloadFullDocLabel}
      />
      <WizardContentBox direction="column">
        <Wizard
          steps={steps}
          step={step}
          path={path}
          text="Step"
          queryString={queryString}
          stepsobj={pageProps.steps.length > 0 ? pageProps.steps : []}
          element={<WizardStepCheckItem />}
          wizardpage={pageName}
          wizardPageModel={arrayModel}
        />
        {videoUrl !== undefined && videoUrl !== '' && <VideoBox videoUrl={videoUrl} id={`${pageName}-${step}-video`} />}
        <WizardStepDescription step={step} steps={steps} />
      </WizardContentBox>
      <PageNavBar
        hide={steps.length === 0}
        prevPage={prevStep}
        nextPage={nextStep}
        history={props.history}
        pageName={`${pageName}-${step}`}
      />
    </PageContentBox>
  );
}
